export const checkIfButtonShouldBeDisabled = (selectedItems, enableOnMultiSelect: boolean | undefined) => {
  if (selectedItems.length <= 0) {
    return true;
  }

  if (selectedItems.length > 1) {
    return !enableOnMultiSelect;
  }

  return false;
};
